import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuild = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5 13.7L6.7 20.5C5.8 21.4 4.4 21.4 3.5 20.5C2.6 19.6 2.6 18.2 3.5 17.3L10.3 10.5C9.5 8.49997 10 6.19997 11.6 4.59997C13.3 2.89997 15.8 2.59997 17.8 3.39997C17.9 3.39997 17.9 3.49997 17.8 3.59997L14.2 7.19997L15.5 8.49997L16.8 9.79997L20.5 6.19997C20.5 6.19997 20.6 6.19997 20.7 6.19997C21.7 8.19997 21.2 10.7 19.5 12.4C17.8 14 15.5 14.4 13.5 13.7Z",
		stroke: "#323232",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBuild);
export default ForwardRef;
